import { SettingsDaiCostsResponse } from './types';

/**
 * 初期導入店舗名・現設置店舗名の絞り込みを適用する
 *
 * セレクター（複数選択）: 表示データに含まれる店舗名のいずれかに完全一致（OR）
 */
export const dataDaiCostsFilteredByHall = (
  dataDaiCost: SettingsDaiCostsResponse,
  initialHallNameMultiSelect: readonly string[] | undefined,
  currentHallNameMultiSelect: readonly string[] | undefined
): SettingsDaiCostsResponse => {
  const initialMulti = initialHallNameMultiSelect ?? [];
  const currentMulti = currentHallNameMultiSelect ?? [];
  const hasInitialMulti = initialMulti.length > 0;
  const hasCurrentMulti = currentMulti.length > 0;

  if (!hasInitialMulti && !hasCurrentMulti) {
    return dataDaiCost;
  }

  const initialMultiSet = new Set(initialMulti);
  const currentMultiSet = new Set(currentMulti);

  const filteredData = dataDaiCost.data.filter((row) => {
    const matchesInitialMulti =
      !hasInitialMulti || initialMultiSet.has(row.initialHallName);
    const matchesCurrentMulti =
      !hasCurrentMulti || currentMultiSet.has(row.currentHallName);
    return matchesInitialMulti && matchesCurrentMulti;
  });

  return {
    ...dataDaiCost,
    data: filteredData,
  };
};
